import { render, staticRenderFns } from "./TypeCertificationDetail.vue?vue&type=template&id=56096cec"
import script from "./TypeCertificationDetail.vue?vue&type=script&lang=js"
export * from "./TypeCertificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports